import { Worker } from "../util";
export default class ObjednavkaRkHromadneCtrl {

  constructor(OdberneMiestoService){
    this.OdberneMiestoService = OdberneMiestoService;
    this.importXls = Worker(this._importXls);
    this.save = Worker(this._save);
    this.file = null;
    this.orders = [];
  }

  onFile($file){
    this.file = $file;
  }

  _importXls(){
    return this.OdberneMiestoService.readDkXls(this.file).then(orders => this.orders = orders);
  }

  _save(){
    return this.OdberneMiestoService.orderDkBatch(this.orders).then(x => {
      this.orders.forEach(order => order.status = 1);
    });
  }

  cancel(){
    this.orders = [];
    this.save = Worker(this._save);
  }

  exportXls(){
    this.OdberneMiestoService.exportDk();
  }

  formatNumber(n){
    if(n === undefined){
      return undefined;
    }
    return (""+(+n).toFixed(3)).replace(".", ",");
  }

}


// WEBPACK FOOTER //
// ./src/RezervovanaKapacita/ObjednavkaDkHromadneCtrl.js